export const theme = {
	background: '#2e4057',
	button1: '#1b998b',
	button2: '#f2c04d',
	text: '#FFFFFF'
	// home:  '#8fff93',
	// signup:  '#61dafb',
	// login:  '#ffff82',
	// userhomepage:  '#ff8f8f',
	// create_account: '#a6e0f7',
	// createteam: '#dfa6f7',
	// jointeam: '#f7d074'
};